/* Copyright (c) 2017 Backpack Health LLC */

import { combineReducers } from 'redux';
import * as _ from 'lodash';

import actionNames from './actionNames';

function fileUploadFlowReducer(state = {
  file: '',
  rawFile: '',
  uploadProgress: 0,
}, action) {
  switch (action.type) {
    case actionNames.fuf_update:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

function changePasswordFlowReducer(state = {
  active: false,
  currentPassword: '',
  currentPasswordIsValid: false,
  passwordStrength: -1,
  newPassword: '',
  newPasswordIsValid: false,
  mfaCode: '',
  mfaCodeIsValid: false,
  passwordsSubmitted: false,
  mfaCodeSubmitted: false,
  passwordSubmitSuccessful: false,
  mfaCodeSubmittedSuccessful: false,
}, action) {
  switch (action.type) {
    case actionNames.cpf_currentPassword:
    case actionNames.cpf_newPassword:
    case actionNames.cpf_mfaCodeSubmitted:
    case actionNames.cpf_update:
      return _.assign({}, state, action.payload);
    case actionNames.cpf_mfaCode:
      return _.assign({}, state, {
        mfaCode: action.payload,
      });
    case actionNames.cpf_passwordsSubmitted:
      return _.assign({}, state, {
        passwordSubmitSuccessful: state.currentPasswordIsValid && state.newPasswordIsValid,
      });
    case actionNames.cpf_passwordSubmitSuccessful:
      return _.assign({}, state, {
        passwordSubmitSuccessful: action.payload,
      });
    case actionNames.cpf_mfaCodeSubmittedSuccessful:
      return _.assign({}, state, {
        mfaCodeSubmittedSuccessful: action.payload,
      });
    case actionNames.cpf_init:
      return _.assign({}, state, {
        active: true,
      });
    case actionNames.cpf_reset:
      return {
        active: false,
        currentPassword: '',
        currentPasswordIsValid: false,
        passwordStrength: -1,
        newPassword: '',
        newPasswordIsValid: false,
        mfaCode: '',
        mfaCodeIsValid: false,
        passwordsSubmitted: false,
        mfaCodeSubmitted: false,
        passwordSubmitSuccessful: false,
        mfaCodeSubmittedSuccessful: false,
      };
    default:
      return state;
  }
}

function enableMfaFlowReducer(state = {
  isInit: false,
  mobileNumber: '',
  mobileNumberIsValid: false,
  mobileNumberSubmitted: false,
  country: '',
  mfaType: 'sms',
  mfaCode: '',
  mfaCodeIsValid: false,
}, action) {
  switch (action.type) {
    case actionNames.emfaf_init:
      return _.assign({}, state, {
        isInit: true,
      });
    case actionNames.emfaf_update:
      return _.assign({}, state, action.payload);
    case actionNames.emfaf_reset:
      return {
        isInit: false,
        mobileNumber: '',
        mobileNumberIsValid: false,
        mobileNumberSubmitted: false,
        country: '',
        mfaType: 'sms',
        mfaCode: '',
        mfaCodeIsValid: false,
      };
    default:
      return state;
  }
}

const apiDataReducer = combineReducers({
  changePasswordFlow: changePasswordFlowReducer,
  fileUploadFlow: fileUploadFlowReducer,
  enableMfaFlow: enableMfaFlowReducer,
});

export default apiDataReducer;
